import { Component } from '@angular/core';

@Component({
    selector: 'app-suport-general-cdms',
    templateUrl: './suport-general-cdms.component.html',
    styleUrls: ['./suport-general-cdms.component.scss'],
    standalone: false
})
export class SuportGeneralCDMSComponent {

}
